import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import StandaloneSurveyPageLayout from "components/v3/layouts/StandaloneSurveyPageLayout";
import CologuardQualificationSurvey from "components/v3/sharedComponents/surveys/CologuardQualificationSurvey";
import { PATHS } from "constants/pathConstants";
import {
  selectCologuardTestRedirectIsEligible,
  selectTestRedirectEligibilitiesLoaded
} from "store/reducers/order/OrderInformationSlice";

const CologuardQualificationSurveyPage = (): React.ReactElement | null => {
  const history = useHistory();
  const eligibilitiesLoaded = useSelector(
    selectTestRedirectEligibilitiesLoaded
  );
  const isEligibleForCologuardTestRedirect = useSelector(
    selectCologuardTestRedirectIsEligible
  );

  useEffect(() => {
    if (eligibilitiesLoaded && !isEligibleForCologuardTestRedirect) {
      history.replace(PATHS.YOUR_NEXT_STEPS);
    }
  }, [eligibilitiesLoaded, history, isEligibleForCologuardTestRedirect]);

  if (eligibilitiesLoaded && !isEligibleForCologuardTestRedirect) {
    return null;
  }

  return (
    <StandaloneSurveyPageLayout
      exitTo={PATHS.YOUR_NEXT_STEPS}
      pageTitle="Colon cancer screening"
      showLogoHeader
    >
      <CologuardQualificationSurvey />
    </StandaloneSurveyPageLayout>
  );
};

export default CologuardQualificationSurveyPage;
